import React from 'react'
import Swiper from 'swiper'

export default class extends React.Component {
  constructor(props) {
    super(props)
    this.swiperChildRef = React.createRef()
  }

  state = {
    rewardIndex: 0,
    itemList: []
  }

  handleSetReward = (e) => {
    this.setState({ rewardIndex: e })
    this.swiperInstance.slideTo(e)
    console.log('itemList', this.state.itemList)
  }

  _hewname(e, op) {
    let { language } = this.props
    let reps = language === 'ar' ? 'rewardNameAr' : language === 'tr' ? 'rewardNameTr' : 'rewardName'
    return e[op] ? e[op][reps] : ''
  }

  _getRewNa(e) {
    let { language } = this.props
    let reps = language === 'ar' ? 'rewardNameAr' : language === 'tr' ? 'rewardNameTr' : 'rewardName'
    return e[reps]
  }

  handleShow(e) {
    if (!e.preview) return
    this.props.onSetActiveMedia(e)
  }

  componentDidMount() {
    const { lang } = this.props
    this.setState({
      itemList: [lang.wealth, lang.charm]
    })
  }

  async componentDidUpdate(prevProps) {
    const { wealthReward, charmReward, language, lang } = this.props

    if (language !== prevProps.language) {
      const itemList = [lang.wealth, lang.charm]
      this.setState({
        itemList: language === 'ar' ? itemList.reverse() : itemList,
        rewardIndex: language === 'ar' ? 1 : 0
      })
    }

    if (
      JSON.stringify(wealthReward) !==
      JSON.stringify(prevProps.wealthReward) ||
      JSON.stringify(charmReward) !==
      JSON.stringify(prevProps.charmReward)
    ) {
      if (!this.swiperInstance) {
        this.initSwiper()
      }
    }
  }

  initSwiper = () => {
    const { language } = this.props
    this.swiperInstance = new Swiper(this.swiperChildRef.current, {
      autoplay: false,
      slidesPerView: 1,
      initialSlide: language === 'ar' ? 1 : 0
      // autoHeight: true
    })

    this.swiperInstance.on('slideChange', (slide) => {
      const { activeIndex } = slide
      this.setState({ rewardIndex: activeIndex })
    })
  }

  renderWealth = () => {
    const {
      wealthReward
    } = this.props

    return (
      <div className="show-reward-info">
        {/* 送礼物奖励 */}
        <div className="top-one-reward">
          <div className="top-one-text">
            <div className="top-one-big">
              <img className="big-text" src="/img/activity/newWeeklyStar/top_noe_textbig.png"></img>
            </div>
          </div>

          { wealthReward['rankReward1'] && (
            <div className="banner-root">
              <img className="banner-one" src={wealthReward['rankReward1'][0].pic || ''}></img>
              <div className="banner-name">{this._hewname(wealthReward['rankReward1'], 0)}</div>
            </div>
          )
          }

          {wealthReward['rankReward1'] &&
            wealthReward['rankReward1'].length > 0 &&
            wealthReward['rankReward1'].slice(1, 5).map((item, index) => (
              <div className="top-item" key={index}>
                <div className="img-bg-root" onClick={() => this.handleShow(item)}>
                  {item.preview && (
                    <img className="oprem" src="/img/activity/newWeeklyStar/open_img.png"></img>
                  )}
                  <img className="re-img" src={item.pic}></img>
                </div>
                <div className="item-name">{this._getRewNa(item)}</div>
              </div>
            ))}
        </div>
        <div className="top-two-reward">
          <div className="top-one-text">
            <div className="top-one-big">
              <img className="big-text" src="/img/activity/newWeeklyStar/top_two_textbig.png"></img>
            </div>
          </div>
          {wealthReward['rankReward2'] &&
            wealthReward['rankReward2'].length > 0 &&
            wealthReward['rankReward2'].map((item, index) => (
              <div className="top-item" key={index}>
                <div className="img-bg-root" onClick={() => this.handleShow(item)}>
                  {item.preview && (
                    <img className="oprem" src="/img/activity/newWeeklyStar/open_img.png"></img>
                  )}
                  <img className="re-img" src={item.pic}></img>
                </div>
                <div className="item-name">{this._getRewNa(item)}</div>
              </div>
            ))}
        </div>
        <div className="top-two-reward">
          <div className="top-one-text">
            <div className="top-one-big">
              <img className="big-text" src="/img/activity/newWeeklyStar/top_three_textbig.png"></img>
            </div>
          </div>
          {wealthReward['rankReward3'] &&
            wealthReward['rankReward3'].length > 0 &&
            wealthReward['rankReward3'].map((item, index) => (
              <div className="top-item" key={index}>
                <div className="img-bg-root" onClick={() => this.handleShow(item)}>
                  {item.preview && (
                    <img className="oprem" src="/img/activity/newWeeklyStar/open_img.png"></img>
                  )}
                  <img className="re-img" src={item.pic}></img>
                </div>
                <div className="item-name">{this._getRewNa(item)}</div>
              </div>
            ))}
        </div>
      </div>
    )
  }

  renderCharm = () => {
    const {
      language,
      charmReward
    } = this.props

    return (
      <div className="reward-small-info">
        {Object.keys(charmReward).map((item, index) => (
          <div className="top-two-reward" key={index}>
            <div className="top-one-text">
              <div className="top-one-big">
                <img
                  className="big-text"
                  src={`/img/activity/newWeeklyStar/top_${
                    index === 0 ? 'noe' : index === 1 ? 'two' : 'three'
                  }_textbig.png`}
                ></img>
              </div>
            </div>
            {charmReward[item].length > 0 &&
              charmReward[item].map((item, index) => (
                <div className="top-item" key={index}>
                  <div className="img-bg-root" onClick={() => this.handleShow(item)}>
                    {item.preview && (
                      <img className="oprem" src="/img/activity/newWeeklyStar/open_img.png"></img>
                    )}
                    <img className="re-img" src={item.pic}></img>
                  </div>
                  <div className="item-name">
                    {language === 'ar'
                      ? item.rewardNameAr
                      : language === 'tr'
                        ? item.rewardNameTr
                        : item.rewardName
                    }
                  </div>
                </div>
              ))}
          </div>
        ))}
      </div>
    )
  }

  render() {
    const {
      language
    } = this.props

    const {
      rewardIndex,
      itemList
    } = this.state

    return (
      <div className="reward-root">
        <div className="send-accept">
          {
            itemList.length > 0 &&
            itemList.map((item, index) => (
              <div
                onClick={() => this.handleSetReward(index)}
                className={`${rewardIndex === index ? 'intheweek' : 'notheweek'}`}
                key={index}
              >
                {item}
              </div>
            ))
          }
        </div>
        <div
          className='swiper-container'
          ref={this.swiperChildRef}
          style={{ direction: language === 'ar' ? 'ltr' : 'inherit' }}
        >
          <div className="swiper-wrapper">
            {
              language !== 'ar' &&
              [this.renderWealth(), this.renderCharm()].map((item, index) => (
                <div className="swiper-slide" key={index}>
                  {item}
                </div>
              ))
            }
            {
              language === 'ar' &&
              [this.renderWealth(), this.renderCharm()].reverse().map((item, index) => (
                <div className="swiper-slide" key={index}>
                  {item}
                </div>
              ))
            }
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/newWeeklyStar/tab-reward.js